import useSWR from "swr";
import useSWRInfinite from "swr/infinite";
import fetcher from "./fetcher";

const baseEndpoint = "/api/influencerEvents";

export function useManagedUpcomingEvents(influencerId) {
  const { data, error, mutate } = useSWR(
    influencerId ? `${baseEndpoint}/${influencerId}/upcoming` : null,
    fetcher,
  );

  return {
    events: data?.events ?? [],
    isLoading: Boolean(influencerId) && !data && !error,
    error,
    refresh: mutate,
  };
}

const pastPageKey = (influencerId, kind) => (pageIndex, previousPage) => {
  const base = `${baseEndpoint}/${influencerId}/past?kind=${kind}`;

  return !influencerId || (pageIndex > 0 && !previousPage?.nextCursor)
    ? null
    : pageIndex === 0
    ? base
    : `${base}&cursor=${previousPage.nextCursor}`;
};

export function usePastEventSeries(influencerId, kind) {
  const { data, error, size, setSize } = useSWRInfinite(
    pastPageKey(influencerId, kind),
    fetcher,
  );
  const pages = data ?? [];

  return {
    series: pages.flatMap((page) => page.series),
    hasMore: Boolean(pages.at(-1)?.nextCursor),
    isLoading: Boolean(influencerId) && !data && !error,
    isLoadingMore: size > pages.length && !error,
    loadMore: () => setSize(size + 1),
    error,
  };
}

export function useManagedEvent(eventId) {
  const { data, error } = useSWR(
    eventId ? `/api/talentDashboard/manageEvent/${eventId}` : null,
    fetcher,
  );

  return {
    event: data?.event ?? null,
    isPast: Boolean(data?.isPast),
    pastOccurrences: data?.pastOccurrences ?? [],
    isLoading: Boolean(eventId) && !data && !error,
    error,
  };
}
